export default "__VITE_ASSET__Bex_xbau__"